const APPROXIMATED_PI_ERROR = "APPROXIMATED_PI_ERROR";
const CHOOSE_CORRECT_NUM_ERROR = "CHOOSE_CORRECT_NUM_ERROR";
const EMPTY_RESPONSE_ERROR = "EMPTY_RESPONSE_ERROR";
const EXTRA_SYMBOLS_ERROR = "EXTRA_SYMBOLS_ERROR";
const FILL_ALL_CELLS_ERROR = "FILL_ALL_CELLS_ERROR";
const INVALID_CHOICE_SELECTION = "INVALID_CHOICE_SELECTION";
const INVALID_SELECTION_ERROR = "INVALID_SELECTION_ERROR";
const MISSING_PERCENT_ERROR = "MISSING_PERCENT_ERROR";
const MULTIPLICATION_SIGN_ERROR = "MULTIPLICATION_SIGN_ERROR";
const NEEDS_TO_BE_SIMPLIFIED_ERROR = "NEEDS_TO_BE_SIMPLIFIED_ERROR";
const NOT_NONE_ABOVE_ERROR = "NOT_NONE_ABOVE_ERROR";
const USER_INPUT_EMPTY = "USER_INPUT_EMPTY";
const USER_INPUT_TOO_LONG = "USER_INPUT_TOO_LONG";
const WRONG_CASE_ERROR = "WRONG_CASE_ERROR";
const WRONG_LETTER_ERROR = "WRONG_LETTER_ERROR";

const ErrorCodes = {
    APPROXIMATED_PI_ERROR,
    CHOOSE_CORRECT_NUM_ERROR,
    EMPTY_RESPONSE_ERROR,
    EXTRA_SYMBOLS_ERROR,
    FILL_ALL_CELLS_ERROR,
    INVALID_CHOICE_SELECTION,
    INVALID_SELECTION_ERROR,
    MISSING_PERCENT_ERROR,
    MULTIPLICATION_SIGN_ERROR,
    NEEDS_TO_BE_SIMPLIFIED_ERROR,
    NOT_NONE_ABOVE_ERROR,
    USER_INPUT_EMPTY,
    USER_INPUT_TOO_LONG,
    WRONG_CASE_ERROR,
    WRONG_LETTER_ERROR,
};

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

export default ErrorCodes;
